import React, { Component } from "react";
import Table from "../../components/Table";
import Filter from "../../components/filter";
import { Plus, Target, Circle, Smartphone } from "react-feather";
import { Link } from "react-router-dom";
import Modal from "../../components/modal";
import { Verify } from "crypto";
import Fuse from "fuse.js";
import moment from "moment";
import Nav from "../../components/Nav";

class Guarantors extends Component {
  state = {
    tableData: { data: [] },
    response: { data: [] },
    tableError: false,
    query: {},
    filter: {},
    table_loading: false
  };
  timeout = null;
  render() {
    return (
      <div className="">
        <div className="mt-3 table-card  border-0 card shado mx-3 shadow">
          <div className="p-4">
            <Table
              search={["firstname"]}
              sort="id"
              sortDirection={-1}
              data={this.state.tableData}
              fetch={params => {
                this.setState({ query: params });
              }}
              loading={this.state.table_loading}
              fetchError={this.state.tableError}
            />
          </div>
        </div>
      </div>
    );
  }

  fetchGuarantors = () => {
    this.setState({ table_loading: true });

    let q = {
      // ...this.state.filter,
      //   customer_id: this.props.match.params.id,
      ...this.state.query,
      borrower_customer_id: this.props.match.params.id
    };

    let urlParams = Object.entries(q)
      .map(e => e.join("="))
      .join("&");

    // //console.log(urlParams);
    fetch(`${window.server}/guarantors?${urlParams}`, {
      headers: {
        Authorization: localStorage.token
      }
    })
      .then(response => response.json())
      .then(response => {
        //console.log(response);

        let data = [];
        response.data.map((d, i) => {
          data.push({
            id: d.id,
            full_name: `${d.guarantor.firstname} ${d.guarantor.middlename} ${d.guarantor.surname}`,
            loan_request_id: d.loan_request_id,
            transaction_id: d.transaction_id,
            guaranteed_amount: "KES " +
              parseFloat(
                parseFloat(d.guaranteed_amount)
              ).toLocaleString(),
            // borrower_customer_id: d.borrower_customer_id,
            // guarantor_customer_id: d.guarantor_customer_id,
            guarantor_status: parseFloat(d.guarantor_status) === 1 ? "Active" : "In active",
            guarantor_ratio: d.guarantor_ratio,
            date_created: moment(d.date_created).format('Do MMMM YYYY, h:mm:ss a'),
            // date_modified: d.date_modified
            action: (
              <div className="d-flex flex-row">
                <Link
                  to={"/member-view/details/" + d.guarantor_customer_id}
                  className="btn btn-sm btn-primary px-3 btn-round"
                >
                  View
                </Link>
              </div>
            )
          });
        });

        let dts = {};
        dts.data = data;

        this.setState({
          tableData: { ...response, ...dts },
          response,
          table_loading: false
        });
      })
      .catch(d => {
        this.setState({ table_loading: false });
        console.error(d);
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify({ ...this.state.query, ...this.state.filter }) !==
      JSON.stringify({ ...prevState.query, ...prevState.filter })
    ) {
      let $t = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        $t.fetchGuarantors();
      }, 100);
    }
  }
}

export default Guarantors;
